import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import './changePassword.css';
import { changePassword } from '../../../api/admins';

const ChangePassword = () => {
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggleOldPasswordVisibility = () => {
        setShowOldPassword(!showOldPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const [formData, setFormData] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handleChange = (e) => {
        e.target.setCustomValidity("")
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.newPassword !== formData.confirmPassword) {
            alert("password is not match")
        } else {
            setLoading(true)
            changePassword(formData.oldPassword, formData.newPassword).then((result) => {
                setLoading(false);
            })
        }
    };

    return (
        <div className="add-brokers-guideline">
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="oldPassword">Old password</label>
                    <div className="search-input-wrapper">
                        <input
                            type={showOldPassword ? 'text' : 'password'}
                            id="oldPassword"
                            name="oldPassword"
                            value={formData.oldPassword}
                            onChange={handleChange}
                            placeholder="Enter old password"
                            style={{ paddingRight: "40px" }}
                            required
                            onInvalid={(e) => e.target.setCustomValidity("Old password is required")}
                        />
                        <button
                            type="button"
                            onClick={toggleOldPasswordVisibility}
                            className="password-toggle"
                            aria-label={showOldPassword ? 'Hide password' : 'Show password'}
                        >
                            {showOldPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="newPassword">New password</label>
                    <div className="search-input-wrapper">
                        <input
                            type={showNewPassword ? 'text' : 'password'}
                            id="newPassword"
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            placeholder="Enter new password"
                            style={{ paddingRight: "40px" }}
                            required
                            onInvalid={(e) => e.target.setCustomValidity("New password is required")}
                        />
                        <button
                            type="button"
                            onClick={toggleNewPasswordVisibility}
                            className="password-toggle"
                            aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                        >
                            {showNewPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="confirmPassword">Confirm new password</label>
                    <div className="search-input-wrapper">
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder="Enter confirm new password"
                            style={{ paddingRight: "40px" }}
                            required
                            onInvalid={(e) => e.target.setCustomValidity('Confirm password is required')}
                        />
                        <button
                            type="button"
                            onClick={toggleConfirmPasswordVisibility}
                            className="password-toggle"
                            aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                        >
                            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                        </button>
                    </div>
                </div>

                {loading ? <div style={{
                    width: "100%",
                    justifyContent: "center",
                    display: "flex"
                }}>
                    <div className="spinner"></div>
                </div> : <button type="submit" className="submit-button">
                    Change password
                </button>}
            </form>
        </div>
    );
};

export default ChangePassword;